import React from 'react';
import PropTypes from 'prop-types';
import PostGrid from '../PostGrid';
import { testAttributes, defaults } from './Constants';
import * as styles from './SpotlightGrid.module.scss';

const SpotlightGrid = ({ 
    cardCount=defaults.cardCount, 
    title=defaults.title, 
    underGrid=null, 
    posts=[] }) => (
    <section className={styles.wrapper} data-testid={testAttributes.WRAPPER}>
        {title}
        <PostGrid posts={posts} postLimit={cardCount} className="postGrid" />
        {
            underGrid? <div className={styles.underGrid} data-testid={testAttributes.UNDER_GRID}>
                {underGrid}
            </div> : null
        }
    </section>
)
SpotlightGrid.propTypes = {
    /** max. number of cards in the grid */
    cardCount: PropTypes.number,
    /** Title component renders above the grid */
    title: PropTypes.node,
    /** Miscellaneous content renders, centered, below the grid */
    underGrid: PropTypes.node,
    /** Array of posts */
    posts: PropTypes.array,
}

export default SpotlightGrid;
